module.exports = __webpack_public_path__ + "d3ed7bcf30f360d2909692ae099e58d3.gif";